import { Typography } from 'antd';
import * as React from 'react';

type InstructionItemProps = {
  children: React.ReactNode;
  number: number;
};

/**
 * Компонент Тектовый контент с номером
 * @param children
 * @param number
 * @constructor
 */
const InstructionItemContent: React.FC<InstructionItemProps> = ({
  children,
  number,
}) => {
  return (
    <Typography.Paragraph>
      <ol start={number}>
        <li>{children}</li>
      </ol>
    </Typography.Paragraph>
  );
};

export default InstructionItemContent;
